module.exports = {
    lists: {
        confirmDeleteTitle: 'Are you sure you would like to delete this list?',
        confirmDeleteSubtext: 'This is permanent and cannot be undone.',
        createListTitle: 'Create new list',
        createListSubtext: 'What are you going to name this list?',
        createListServerErrorText: 'Could not communicate with the server.',
        createListPatternValidationText: 'Certain symbols (e.g. & < > ") give Lists a headache.',
        createListExistingValidationText: 'Ah! You already have a list with this name.',
        createListRequiredValidationText: 'A list name is required.',
        createListSmallLength: 4,
        createListSmallLengthText: 'This name is a good length :)',
        createListMediumLength: 18,
        createListMediumLengthText: 'It\'s getting a bit long now.',
        createListLargeLength: 30,
        createListLargeLengthText: 'You\'re going to run out of characters soon...',
        createListMaxLength: 36,
        createListMaxLengthText: 'OK, that\'s the character limit!',
        listsTitleText: 'Welcome back,',
        myListTitleText: 'My Lists',
        enableListHome: false,
        myWoolworthsRewardsListPageHeading: 'Products I Purchased with my Woolworths Rewards Card',
        noPastShopsMessage: 'No past shop exists.',
        myListsShowMoreThreshold: 4,
        pastShopsShowMoreThreshold: 3,
        includedDepartmentIds: ['1-E5BEE36E', '1_D5A2236', '1_DEB537E', '1_6E4F4E4', '1_39FD49C', '1_ACA2FC2', '1_5AF3A0A', '1_C8BFD01', '1_B63CF9E', '1_61D6FEB', '1_717A94B', '1_894D0A8', '1_2432B58'],
        groupByName: 'Categorise',
        suggestedListsToolTipText: 'Our Suggested Lists are designed to inspire you with products you might like to add to your own lists.',
        allProductsTitle: 'All Products',
        allProductsSubTitle: 'Every product you\'ve ever bought conveniently brought together in one list.',
        allProductsCta: 'View now',
        allProductsUnavailableText: 'Unavailable until first shop is complete',
        pastShopsTitle: 'Past Shops',
        pastShopsSubTitle: 'Browse all your past shops',
        pastShopsCta: 'View now',
        pastShopsUnavailableText: 'Unavailable until first shop is complete',
        previouslyBoughtText: 'Previously Bought',
        linkRewardsText: 'Have you linked your rewards card?',
        linkRewardsToolTip: 'When you link your Rewards Card we’re able to connect both your online and in-store purchases, bringing them together under All Products.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/lists.js